export const datasourceTableHeaders = [
  '#',
  'Name',
  'Source',
  'Collection',
  'Created Date',
  'Action',
];
export const externalApisTableHeaders = [
  'Name',
  'Type',
  'Collection',
  'Response',
  'Created Date',
  'In Use',
  'Action',
];
